import React from 'react';
import PropTypes from 'prop-types';
import {
  AccountTreeOutlined as AccountTreeOutlinedIcon,
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  AttachFile as AttachFileIcon,
  Bolt as BoltIcon,
  Check as CheckIcon,
  ChevronRight as ChevronRightIcon,
  Close as CloseIcon,
  ConstructionOutlined as ConstructionOutlinedIcon,
  ContentCopy as ContentCopyIcon,
  DeleteOutline as DeleteOutlineIcon,
  DownloadOutlined as DownloadOutlinedIcon,
  EditOutlined as EditOutlinedIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  FilterList as FilterListIcon,
  FolderOpenOutlined as FolderOpenOutlinedIcon,
  FolderOutlined as FolderOutlinedIcon,
  InfoOutlined as InfoOutlinedIcon,
  InsertDriveFileOutlined as InsertDriveFileOutlinedIcon,
  Menu as MenuIcon,
  MoreVert as MoreVertIcon,
  NorthEast as NorthEastIcon,
  NoteAddOutlined as NoteAddOutlinedIcon,
  PlayArrow as PlayArrowIcon,
  Refresh as RefreshIcon,
  SaveOutlined as SaveOutlinedIcon,
  ScienceOutlined as ScienceOutlinedIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  ShareOutlined as ShareOutlinedIcon,
  StickyNote2Outlined as StickyNote2OutlinedIcon,
  Stop as StopIcon,
  Terminal as TerminalIcon,
  ViewListOutlined as ViewListOutlinedIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';
import './Icon.css';

/**
 * Curated Onyx icon registry. Import icons only through this wrapper.
 * Sizes: sm 16 / md 20 / lg 24. Color inherits via currentColor.
 */
const REGISTRY = {
  add: AddIcon,
  arrowBack: ArrowBackIcon,
  arrowForward: ArrowForwardIcon,
  attach: AttachFileIcon,
  bolt: BoltIcon,
  build: ConstructionOutlinedIcon,
  check: CheckIcon,
  chevron: NorthEastIcon,
  chevronRight: ChevronRightIcon,
  close: CloseIcon,
  copy: ContentCopyIcon,
  delete: DeleteOutlineIcon,
  download: DownloadOutlinedIcon,
  edit: EditOutlinedIcon,
  expand: ExpandMoreIcon,
  expandLess: ExpandLessIcon,
  file: InsertDriveFileOutlinedIcon,
  filter: FilterListIcon,
  folder: FolderOutlinedIcon,
  folderOpen: FolderOpenOutlinedIcon,
  info: InfoOutlinedIcon,
  menu: MenuIcon,
  more: MoreVertIcon,
  note: StickyNote2OutlinedIcon,
  noteAdd: NoteAddOutlinedIcon,
  pipeline: AccountTreeOutlinedIcon,
  play: PlayArrowIcon,
  refresh: RefreshIcon,
  save: SaveOutlinedIcon,
  science: ScienceOutlinedIcon,
  search: SearchIcon,
  send: ArrowUpwardIcon,
  settings: SettingsIcon,
  share: ShareOutlinedIcon,
  stop: StopIcon,
  terminal: TerminalIcon,
  viewList: ViewListOutlinedIcon,
  warning: WarningAmberIcon,
};

export const ICON_NAMES = Object.keys(REGISTRY);

export function Icon({ name, size = 'md', className = '', title, ...props }) {
  const Cmp = REGISTRY[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`Icon: unknown name "${name}". Allowed: ${ICON_NAMES.join(', ')}`);
    }
    return null;
  }
  return (
    <Cmp
      className={['onyx-icon', `onyx-icon--${size}`, className].filter(Boolean).join(' ')}
      fontSize="inherit"
      titleAccess={title}
      data-testid={`onyx-icon-${name}`}
      {...props}
    />
  );
}

Icon.propTypes = {
  name: PropTypes.oneOf(ICON_NAMES).isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  title: PropTypes.string,
};

export default Icon;
